import CloudflarePlayer from "./CloudflarePlayer";

export default CloudflarePlayer;
